<template>
    <header id="site-header" v-if="isDataLoaded">

        <nav class="not-show-mobile base-navbar">
            <div class="base-navbar-container">
                <div class="navbar-left">
                    <template v-for="(item, index) in topMenu">
                        <div v-if="index != 0" class="m-0 font-thin">|</div>
                        <div class="navbar__redirect-link"><a data-ga-group="header" data-ga-element="item" v-if="item.menuLink" class="nav-link" :href="formattedMenuLink(item.menuLink)">{{ item.menuLabel }}</a><span v-else>{{ item.menuLabel }}</span></div>
                    </template>
                </div>
                <div class="navbar-right">
                    <header-account :desktopUser="true" />
                    <div class="flex lg:px-[5px]">
                        <button class="btn-icon pop-overlay announcement_mobile_btn" @click="toggleAnnouncement" data-ga-group="header" data-ga-element="announcement">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" class="navbar-notification-button">
                                <g id="Group_10485" data-name="Group 10485" transform="translate(-5109 -13508)">
                                    <rect id="Rectangle_653" data-name="Rectangle 653" width="24" height="24" transform="translate(5109 13508)" fill="none"></rect>
                                    <path id="Path_474" data-name="Path 474" d="M-7-14a1,1,0,0,0-1,1v.6a5,5,0,0,0-4,4.9v.588a6.014,6.014,0,0,1-1.516,3.987l-.231.259a1,1,0,0,0-.166,1.075A1,1,0,0,0-13-1H-1a1,1,0,0,0,.913-.591A1,1,0,0,0-.253-2.666l-.231-.259A6.008,6.008,0,0,1-2-6.912V-7.5a5,5,0,0,0-4-4.9V-13a1,1,0,0,0-1-1ZM-5.584,1.416A2,2,0,0,0-5,0H-9a2,2,0,0,0,.584,1.416A2,2,0,0,0-7,2,2,2,0,0,0-5.584,1.416Z" transform="translate(5128 13526)"></path>
                                </g>
                            </svg>
                            <div v-if="unread > 0" class="announcement__unread-hint-container">{{ unread }}</div>
                        </button>
                    </div>
                    <div class="flex lg:px-[5px]">
                        <div class="hidden lg:flex">
                            <button class="btn-icon flex items-center pop-overlay" @click="toggleSearch" data-ga-group="header" data-ga-element="search_button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" height="24" width="24" class="navbar-announcement-button" fill="white">
                                    <g id="Group_10471" data-name="Group 10471" transform="translate(-4759 -13436)">
                                        <rect id="Rectangle_640" data-name="Rectangle 640" width="40" height="40" transform="translate(4759 13436)" fill="none"></rect>
                                        <path id="Icon" d="M18.912,20.515h0L13.078,14.68a8.161,8.161,0,1,1,1.6-1.6l5.834,5.834-1.6,1.6ZM8.163,2.267a5.9,5.9,0,1,0,5.9,5.9A5.9,5.9,0,0,0,8.163,2.267Z" transform="translate(4768.743 13445.742)"></path>
                                    </g>
                                </svg>
                                <span class="sr-only">search</span>
                            </button>
                            <div class="header-overlay-container header-overlay-container-search z-60 !bg-[#000]" :class="searchOpen ? '' : 'hidden'">
                                <div class="announcement-mweb">
                                    <div class="header-overlay__top-bar">
                                        <div class="w-full ">
                                            <template>
                                                <a :href="logoLink && logoLink.uri ? formattedMenuLink(logoLink):'#'" data-ga-group="menu_bar" data-ga-element="logo">
                                                    <template v-if="whiteSiteLogo && whiteSiteLogo.imageMedia && whiteSiteLogo.imageMedia.file.url">
                                                        <img class="headerLogo" :src="whiteSiteLogo.imageMedia.file.url" alt="wk logo black" :style="headerLogoStyle"/>
                                                    </template>
                                                    <template v-else>
                                                        <div class="headerLogo" v-html="textLogo.processed" alt="wk logo black" :style="headerLogoStyle"></div>
                                                    </template>
                                                </a>
                                            </template>
                                        </div>
                                        <button class="btn-close-2 header-overlay__close-button" @click="toggleSearch">
                                            <img alt="menu_slash" loading="lazy" width="40" height="40" decoding="async" data-nimg="1" class="fill-black" src="/images/icons/close.svg" style="color: transparent;">
                                        </button>
                                    </div>
                                    <div class="overflow-y-scroll w-full ">
                                        <div class="flex flex-col w-[calc(100vw-40px)] overflow-y-scroll overflow-x-hidden lg:max-w-[800px] mx-auto justify-between relative">
                                            <div class="font-bold relative self-start uppercase text-white text-[30px] lg:text-[36px] mt-[20px] lg:mt-[8px] mb-[24px] undefined">
                                                Search</div>
                                            <label for="default-search" class="mb-[23px] text-sm font-medium text-gray-900 sr-only">Search</label>
                                            <form class="relative lg:max-w-[800px] h-[52px] mb-[30px]" :action="$store.getters.getBaseUrl + '/' + $i18n.locale + '/search'">
                                                <input class="!outline-none rounded-full block w-full  p-4 text-sm text-gray-900 border " placeholder="Look For Something? Type Here" required="" name="searchTerm" type="search">
                                                <button type="submit" class="text-[#4F4E4E] lg:w-[114px] lg:h-[36px] absolute right-[4px] bottom-[-3px] lg:right-[12px] lg:bottom-[5px] !bg-[#C7C2B5] rounded-full  ">
                                                    <svg class="w-[21px] h-[21px] lg:hidden block text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"></path>
                                                    </svg>
                                                    <div class="hidden lg:block font-bold">Search</div>
                                                </button>
                                            </form>
                                            <div class="mb-[30px]">
                                                <a href="">
                                                    <div class="text-white flex h-[26px] text-[22px] leading-6">What’s On <span class="text-[16px] mx-4">/</span></div>
                                                </a>
                                            </div>
                                            <div class="w-[calc(100vw-40px)]">
                                                <div class="w-[801px] lg:h-[70px] flex flex-wrap">
                                                    <template v-for="(item, index) in popularSearchKeywords">
                                                        <div class="font-light">
                                                            <a :href="$store.getters.getBaseUrl + '/' + $i18n.locale + '/search?searchTerm=' + item">
                                                                <button type="button" class="text-white border border-white focus:ring-4 focus:outline-none focus:ring-gray-300 font-bold rounded-lg text-[14px] leading-[24px] px-3 py-2 text-center mx-2 mb-[10px]">{{ item }}</button>
                                                            </a>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="language-switcher group">
                        <button class="btn-icon nav__language-switcher-button" data-ga-group="header" data-ga-element="languages_menu">
                            {{ $i18n.locale == 'en' ? 'EN' : ($i18n.locale == 'tc' ? '繁' : '简') }}
                            <svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" class="nav__language-switcher-icon">
                                <g id="Group_10483" data-name="Group 10483" transform="translate(-5013 -13508)">
                                    <rect id="Rectangle_649" data-name="Rectangle 649" width="24" height="24" transform="translate(5013 13508)" fill="none"></rect>
                                    <path id="Path_451" data-name="Path 451" d="M7.133.883a1.252,1.252,0,0,1-1.77,0l-5-5A1.245,1.245,0,0,1,.094-5.48,1.251,1.251,0,0,1,1.25-6.254h10a1.255,1.255,0,0,1,1.156.773,1.252,1.252,0,0,1-.27,1.363l-5,5Z" transform="translate(5018.569 13522.555)"></path>
                                </g>
                            </svg></button>
                        <div class="language-switcher-li group-focus-within">
                            <button class="btn-icon px-3 py-2 hover:bg-gray-700 rounded-full" v-if="$i18n.locale != 'en'"><a href="/en" @click.prevent="updateLocale('en')">EN</a></button>
                            <button class="btn-icon px-3 py-2 hover:bg-gray-700 rounded-full" v-if="$i18n.locale != 'tc'"><a href="/tc" @click.prevent="updateLocale('tc')">繁</a></button>
                            <button class="btn-icon px-3 py-2 hover:bg-gray-700 rounded-full" v-if="$i18n.locale != 'sc'"><a href="/sc" @click.prevent="updateLocale('sc')">简</a></button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>

        <header-announcement @toggleAnnouncement="toggleAnnouncement" :announcementOpen="announcementOpen" :unread.sync="unread" @setUnread="setUnread"/>

        <div class="">
            <nav style="top: 36px;" class="navbar-fixed-top navbar-fixed-top--linear-background navbar--solid-bg">
                <div class="navbar">
                    <template>
                        <a :href="logoLink && logoLink.uri ? formattedMenuLink(logoLink):'#'" data-ga-group="menu_bar" data-ga-element="logo">
                            <template v-if="blackSiteLogo && blackSiteLogo.imageMedia && blackSiteLogo.imageMedia.file.url">
                                <img class="headerLogo" :src="blackSiteLogo.imageMedia.file.url" alt="wk logo black" :style="headerLogoStyle"/>
                            </template>
                            <template v-else>
                                <div class="headerLogo" v-html="textLogo.processed" alt="wk logo black" :style="headerLogoStyle"></div>
                            </template>
                        </a>
                    </template>
                    
                    <div class="second-navbar__button-container lg:hidden">
                        <div class=" group flex !mr-2">
                            <button class="announcement_mobile_btn" @click="toggleAnnouncement" data-ga-group="header" data-ga-element="announcement">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="white" class="navbar-notification-button">
                                    <g id="Group_10485" data-name="Group 10485" transform="translate(-5109 -13508)">
                                        <rect id="Rectangle_653" data-name="Rectangle 653" width="24" height="24" transform="translate(5109 13508)" fill="none"></rect>
                                        <path id="Path_474" data-name="Path 474" d="M-7-14a1,1,0,0,0-1,1v.6a5,5,0,0,0-4,4.9v.588a6.014,6.014,0,0,1-1.516,3.987l-.231.259a1,1,0,0,0-.166,1.075A1,1,0,0,0-13-1H-1a1,1,0,0,0,.913-.591A1,1,0,0,0-.253-2.666l-.231-.259A6.008,6.008,0,0,1-2-6.912V-7.5a5,5,0,0,0-4-4.9V-13a1,1,0,0,0-1-1ZM-5.584,1.416A2,2,0,0,0-5,0H-9a2,2,0,0,0,.584,1.416A2,2,0,0,0-7,2,2,2,0,0,0-5.584,1.416Z" transform="translate(5128 13526)"></path>
                                    </g>
                                </svg>
                                <div v-if="unread > 0" class="announcement__unread-hint-container">{{ unread }}</div>
                            </button>
                        </div>
                        <div class=" !mr-2">
                            <button class=" flex  items-center" data-ga-group="header" data-ga-element="search_button">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" height="24" width="24" class="navbar-announcement-button" fill="white">
                                    <g id="Group_10471" data-name="Group 10471" transform="translate(-4759 -13436)">
                                        <rect id="Rectangle_640" data-name="Rectangle 640" width="40" height="40" transform="translate(4759 13436)" fill="none"></rect>
                                        <path id="Icon" d="M18.912,20.515h0L13.078,14.68a8.161,8.161,0,1,1,1.6-1.6l5.834,5.834-1.6,1.6ZM8.163,2.267a5.9,5.9,0,1,0,5.9,5.9A5.9,5.9,0,0,0,8.163,2.267Z" transform="translate(4768.743 13445.742)"></path>
                                    </g>
                                </svg>
                                <span class="sr-only">search</span>
                            </button>
                        </div>
                        <button class="dropdown-open lg:hidden " @click="toggleMobileMenu">
                            <span class="sr-only">Open main menu</span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40">
                                <g id="Group_10476" data-name="Group 10476" transform="translate(-4946 -13437)">
                                    <rect id="Rectangle_644" data-name="Rectangle 644" width="40" height="40" transform="translate(4946 13437)"></rect>
                                    <g id="Group_10477" data-name="Group 10477" transform="translate(4953.411 13449.54)">
                                        <line id="Line_4" data-name="Line 4" x2="25.177" transform="translate(0 0)" fill="none" stroke="white" stroke-width="3"></line>
                                        <line id="Line_5" data-name="Line 5" x2="25.177" transform="translate(0 7.46)" fill="none" stroke="white" stroke-width="3"></line>
                                        <line id="Line_6" data-name="Line 6" x2="12.122" transform="translate(13.055 14.92)" fill="none" stroke="white" stroke-width="3"></line>
                                    </g>
                                </g>
                            </svg>
                        </button>
                        <button disabled="" type="button" class="text-gray-400 bg-transparent flex items-center justify-center  hidden ">
                            <svg class="w-[24px] h-[24px]" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"></path>
                            </svg>
                            <span class="sr-only">Close menu</span>
                        </button>
                    </div>
                    <div class=" hidden lg:flex">


                        <ul class="hidden lg:flex items-center relative">
                            <template v-for="(item, index) in headerMenu">
                                <div class="second-nav-link__container" @mouseover="onSelectedDropdownShow(index + 1, $event)" @mouseleave="onSelectedDropdownShow(undefined, $event)">
                                    <button class="peer second-nav-link" data-ga-group="menu_bar" data-ga-element="menu">
                                        <a v-if="item.menuLink" :href="formattedMenuLink(item.menuLink)" class="navbarList hover-animation hover:bg-transparent ">{{ item.menuLabel }}</a>
                                        <span v-else class="navbarList hover-animation hover:bg-transparent ">{{ item.menuLabel }}</span>
                                    </button>
                                    <div class="dropdown-menu__hover-section" v-if="selectedDropdown == (index + 1) && item.childMenuParagraph"></div>
                                    <div class="dropdown-menu peer-hover:flex" v-if="selectedDropdown == (index + 1) && item.childMenuParagraph">
                                        <div class="dropdown-menu-border">
                                            <div class="dropdown-menu-first">
                                                <!--<button class="first-level-link" :class="selectedSubMenu=='77e9022e-e3ea-4e1d-95bb-14f2fe53e09e' ? 'pop-open' : ''" @click="onSelectedSubMenu('77e9022e-e3ea-4e1d-95bb-14f2fe53e09e')">
										  <button class="dropdown__link-text link">
											<div class="dropdown__link-menu_label">Events/Programmes</div>
											<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#EF6602">
												<g id="Group_10482" data-name="Group 10482" transform="translate(-4987 -13508)">
													<rect id="Rectangle_648" data-name="Rectangle 648" width="24" height="24" transform="translate(4987 13508)" fill="none"></rect>
													<path id="Path_450" data-name="Path 450" d="M3.822,0,7.171,5.8,3.438,11.608H0L4.166,5.719.612,0Z" transform="translate(4995.395 13514.195)"></path>
												</g>
											</svg>
										  </button>
										</button> /-->
                                                <template v-for="(childitem, childindex) in item.childMenuParagraph">
                                                    <button class="first-level-link" :uuid="childitem.uuid" :class="selectedSubMenu == childitem.uuid ? 'pop-open' : ''" @click="onSelectedSubMenu(childitem.uuid, childitem.childMenuParagraph, childitem.menuLink ? formattedMenuLink(childitem.menuLink) : null)">
                                                        <button class="dropdown__link-text link">
                                                            <div class="dropdown__link-menu_label">
                                                                {{ childitem.menuLabel }}
                                                            </div>
                                                            <svg v-if="childitem.childMenuParagraph" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20" height="20" fill="#EF6602">
                                                                <g id="Group_10482" data-name="Group 10482" transform="translate(-4987 -13508)">
                                                                    <rect id="Rectangle_648" data-name="Rectangle 648" width="24" height="24" transform="translate(4987 13508)" fill="none"></rect>
                                                                    <path id="Path_450" data-name="Path 450" d="M3.822,0,7.171,5.8,3.438,11.608H0L4.166,5.719.612,0Z" transform="translate(4995.395 13514.195)"></path>
                                                                </g>
                                                            </svg>
                                                        </button>
                                                    </button>
                                                </template>
                                            </div>
                                            <template v-for="(childitem, childindex) in item.childMenuParagraph">
                                                <div class="second-level-menu" v-if="childitem.childMenuParagraph && selectedSubMenu == childitem.uuid">
                                                    <template v-for="(childitem_v2, child_v2index) in childitem.childMenuParagraph">
                                                        <button class="link second-level-link"><a v-if="childitem_v2.menuLink" :href="formattedMenuLink(childitem_v2.menuLink)" class="!text-black">{{ childitem_v2.menuLabel }}</a><span v-else>{{ childitem_v2.menuLabel }}</span></button>
                                                    </template>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <li v-if="headerButton" class="text-[14px] lg:text-[16px] font-bold navbar__header-button">
                                <a v-if="headerButton.uri" :href="headerButton.uri" data-ga-group="menu_bar" data-ga-element="cta_button">
                                    <button class="button--bestia border lg:h-[36px]  border-white ">
                                        <div class=" button__bg"></div><span>{{ headerButton.title }}</span><span v-else>{{ headerButton.title }}</span>
                                    </button>
                                </a>
                            </li>
                        </ul>

                    </div>
                </div>
            </nav>
        </div>

        <div class="dropdown-container mobile-menu" :class="mobileMenuOpen ? '' : 'hidden'">
            <div class="rounded-t-xl bg-white">
                <div class="dropdown-mnavbar">
                    <template>
                        <a :href="logoLink && logoLink.uri ? formattedMenuLink(logoLink):'#'" data-ga-group="menu_bar" data-ga-element="logo">
                            <template v-if="blackSiteLogo && blackSiteLogo.imageMedia && blackSiteLogo.imageMedia.file.url">
                                <img class="headerLogo" :src="blackSiteLogo.imageMedia.file.url" alt="wk logo black" :style="headerLogoStyle"/>
                            </template>
                            <template v-else>
                                <div class="headerLogo" v-html="textLogo.processed" alt="wk logo black" :style="headerLogoStyle"></div>
                            </template>
                        </a>
                    </template>
                    <button class="dropdown-close" @click="toggleMobileMenu">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 40 40">
                            <g id="Group_10479" data-name="Group 10479" transform="translate(-4853 -13500)">
                                <rect id="Rectangle_645" data-name="Rectangle 645" width="32" height="32" transform="translate(4853 13500)" fill="none"></rect>
                                <g id="Group_10473" data-name="Group 10473" transform="translate(4532 13493.558)">
                                    <path id="Union_1" fill="#000000" data-name="Union 1" d="M-4521.394-13480.832l-8.486,8.486-2.12-2.119,8.487-8.486-8.487-8.486,2.12-2.12,8.486,8.486,8.486-8.486,2.12,2.12-8.486,8.486,8.486,8.486-2.12,2.119Z" transform="translate(4862.394 13509.301)"></path>
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div class="mweb_menu">
                    <template v-for="(item, index) in topMenu">
                        <div :class="[index === topMenu.length - 1 ? 'mb-[15px]' : '', 'menu_item_top']"><a data-ga-group="header" data-ga-element="item" v-if="item.menuLink" class="nav-link" :href="formattedMenuLink(item.menuLink)">{{ item.menuLabel }}</a><span v-else>{{ item.menuLabel }}</span></div>
                    </template>
                    <template v-for="(item, index) in headerMenu">
                        <div class="mobile-nav-dropdown__second-menu-item-container">
                            <div class="mobile-nav-dropdown__second-menu-item">
                                <h2 class="navItem mr-[15px]">
                                    <a data-ga-group="header" data-ga-element="item" v-if="item.menuLink" class="nav-link" :href="formattedMenuLink(item.menuLink)">{{ item.menuLabel }}</a><span v-else>{{ item.menuLabel }}</span>
                                </h2>
                                <div class="" @click="onMobileSelectedDropdownShow(index + 1)">
                                    <div class="">
                                        <img alt="dropdownicon" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" class="dropdownicon m-[0.5] self-start bg-undefined stroke-black" src="/images/icons/drop-down.svg" style="color: transparent;">
                                    </div>
                                </div>
                            </div>

                            <div class="mobile-sub-root-div mobile-sub-hidden" :class="'mobile-sub-vertical' + (index + 1)">
                                <div class="mobile-sub-root mobile-sub-vertical" style="min-height: 0px;">
                                    <div class="mobile-sub-wrapper mobile-sub-vertical mobile-sub-wrapper">
                                        <div class="mobile-sub-wrapperInner mobile-sub-vertical mobile-sub-wrapperInner">
                                            <template v-for="(childitem, childindex) in item.childMenuParagraph">
                                                <div class="navSubItem" @click="onMobileSelectedSubMenu(index + 1, childindex + 1)">
                                                    <a v-if="childitem.menuLink" :href="formattedMenuLink(childitem.menuLink)">{{ childitem.menuLabel }}</a>
                                                    <span v-else>{{ childitem.menuLabel }}</span>
                                                    <div v-if="childitem.childMenuParagraph" class="">
                                                        <img alt="dropdownicon" loading="lazy" width="22" height="22" decoding="async" data-nimg="1" class="dropdownicon m-[0.5] self-start bg-undefined stroke-black" src="/images/icons/drop-down.svg" style="color: transparent;">
                                                    </div>
                                                </div>
                                                <template v-if="childitem.childMenuParagraph">
                                                    <div class="mob-second-level-menu-div mobile-sub-hidden" :class="'mob-second-level-menu' + (index + 1) + (childindex + 1)">
                                                        <div class="mob-second-level-menu">
                                                            <button class="link mob-second-level-link" v-for="(subchilditem, subchildindex) in childitem.childMenuParagraph">
                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16" height="16" class="mobile-nav-dropdown__third-menu-item-arrow">
                                                                    <g id="Group_10482" data-name="Group 10482" transform="translate(-4987 -13508)">
                                                                        <rect id="Rectangle_648" data-name="Rectangle 648" width="24" height="24" transform="translate(4987 13508)" fill="none"></rect>
                                                                        <path id="Path_450" data-name="Path 450" d="M3.822,0,7.171,5.8,3.438,11.608H0L4.166,5.719.612,0Z" transform="translate(4995.395 13514.195)"></path>
                                                                    </g>
                                                                </svg>
                                                                <a v-if="subchilditem.menuLink" :href="formattedMenuLink(subchilditem.menuLink)" class="!text-black">{{ subchilditem.menuLabel }}</a>
                                                                <span v-else class="!text-black">{{ subchilditem.menuLabel }}</span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </template>
                                            </template>


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>


                    <div class="mweb_menu_social">
                        <div class="flex">
                            <template v-for="(mediaIcon, index) in socialMediaIcons">
                                <a :href="mediaIcon.iconLink.uri" target="_blank" class="mx-2">
                                    <img :src="mediaIcon.iconImage.file.url" :alt="mediaIcon.iconImage.altText">
                                    <span class="sr-only">{{ mediaIcon.iconImage.altText }}</span>
                                </a>
                            </template>

                        </div>
                    </div>
                </div>
                <div class="mweb_menu_footer">
                    <div class="flex lg:hidden">
                        <button class="m-navar__language-item" v-if="$i18n.locale != 'en'"><a href="/en" @click.prevent="updateLocale('en')">EN</a></button>
                        <button class="m-navar__language-item" v-if="$i18n.locale != 'tc'"><a href="/tc" @click.prevent="updateLocale('tc')">繁</a></button>
                        <button class="m-navar__language-item" v-if="$i18n.locale != 'sc'"><a href="/sc" @click.prevent="updateLocale('sc')">简</a></button>
                    </div>
                    <header-account :desktopUser="false" />
                </div>
            </div>
        </div>
    </header>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex"
import SearchIcon from "@/components/layout/header/icons/SearchIcon"
import UserIcon from "@/components/layout/header/icons/UserIcon"
import CartIcon from "@/components/layout/header/icons/CartIcon"
import MegaMenu from "@/components/layout/header/MegaMenu/MegaMenu"
import MobileMenu from "@/components/layout/header/MobileMenu/MobileMenu"
import HeaderSearch from "@/components/layout/header/HeaderSearch"
import HeaderAnnouncement from "@/components/layout/header/HeaderAnnouncement"
import HeaderLogo from "@/components/layout/header/icons/HeaderLogo"
import HeaderAccount from "@/components/layout/header/HeaderAccountNew"

export default {
    name: "app-header",
    components: {
        SearchIcon,
        UserIcon,
        CartIcon,
        MegaMenu,
        MobileMenu,
        HeaderSearch,
        HeaderAnnouncement,
        HeaderLogo,
        HeaderAccount
    },
    data() {
        return {
            searchOpen: false,
            mobileMenuOpen: false,
            announcementOpen: false,
            selectedDropdown: undefined,
            selectedSubMenu: undefined,
            unread: 0,
            isMobile: window.innerWidth <= 1230,
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleScroll);
        window.addEventListener("resize", this.handleResize);
    },
    mounted() {
        this.handleScroll();
        window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    unmounted() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleScroll);
    },
    methods: {
        toggleSearch() {
            this.searchOpen = !this.searchOpen
        },
        toggleAnnouncement() {
            this.announcementOpen = !this.announcementOpen
        },
        setUnread(_unread) {
            this.unread = _unread
        },
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen

            const body = document.getElementById('body');

            if (this.mobileMenuOpen) {
                body.classList.add('body--locked');
            } else {
                body.classList.remove('body--locked');
            }
        },
        updateLocale(locale) {
            this.$i18n.locale = locale;
        },
        goToCart() {
            this.$router.push({ name: "shopping-cart", params: { locale: this.$i18n.locale } });
        },
        toggleDebug() {
            this.updateDebug(!this.debugging);
        },
        ...mapActions(["updateDebug", 'updateLoading']),
        onSelectedDropdownShow(index, event) {
            if (index == undefined) {
                this.selectedSubMenu = undefined;
            }
            this.selectedDropdown = index;
            if (index != undefined) {
                setTimeout(function () {
                    const dropdown = document.getElementsByClassName('dropdown-menu')[0];
                    var narLeft = document.getElementsByClassName('second-nav-link')[0].parentElement.getBoundingClientRect().left;
                    var menuLeft = dropdown.parentElement.getBoundingClientRect().left;
                    var dropdown_right = menuLeft + dropdown.offsetWidth;
                    var right = window.innerWidth - dropdown_right;
                    if (right < 0) {
                        dropdown.style.left = "unset";
                        dropdown.style.right = "0px";
                    } else {
                        dropdown.style.left = menuLeft - narLeft + "px";
                        dropdown.style.right = "unset";
                    }
                    dropdown.style.opacity = 1;
                }, 10);
            }
        },
        onSelectedSubMenu(uuid, hasChild, ahref) {
            if (ahref) {
                var a_href = ahref.indexOf("http") > -1 ? ahref : process.env.VUE_APP_WK_FRONT_END_URL + ahref;
                if (hasChild) {
                    if (this.selectedSubMenu && this.selectedSubMenu == uuid) {
                        document.location.href = a_href;
                    }
                } else {
                    document.location.href = a_href;
                }
            }
            if (uuid) {
                this.selectedSubMenu = uuid;
                setTimeout(function () {
                    const dropdown = document.getElementsByClassName('dropdown-menu')[0];
                    // const dropdown_right = document.getElementsByClassName('dropdown-menu')[0].getBoundingClientRect().right;
                    const dropdown_right = dropdown.parentElement.getBoundingClientRect().left + dropdown.offsetWidth;
                    var right = window.innerWidth - dropdown_right;
                    // dropdown.style.left = (right < 0 ? right - 53 : 0) + "px";
                    if (right < 0) {
                        dropdown.style.left = "unset";
                        dropdown.style.right = "0px";
                    }
                }, 10);
            }
        },
        onMobileSelectedDropdownShow(index) {
            var subMenu = document.querySelectorAll(".mobile-sub-vertical" + index);
            subMenu[0].classList.toggle('mobile-sub-hidden');
            // if(subMenu[0].classList.indexOf("mobile-sub-hidden") > 0){
            //     var subSubMenus = document.querySelectorAll("[class^='.mob-second-level-menu"+index+"']");
            //     console.log(subSubMenus);
            //     for (let subSubMenu in subSubMenus) {
            //         if(subSubMenu.classList.indexOf("mobile-sub-hidden") < 0){
            //             subSubMenu.classList.add('mobile-sub-hidden');
            //         }
            //     }
            // }
        },
        onMobileSelectedSubMenu(index, childindex) {
            var subMenu = document.querySelectorAll(".mob-second-level-menu" + index + childindex);
            subMenu[0].classList.toggle('mobile-sub-hidden');
        },
        handleScroll() {

            const NavbarPosition = 36;
            const windowHeight = window.innerHeight;
            let stickyPosition = window.innerWidth >= 1440 ? (NavbarPosition - window.scrollY > 0 ? NavbarPosition - window.scrollY : 0) : 0;
            var Navbar = document.querySelector(".navbar-fixed-top");
            Navbar.style.top = stickyPosition + "px";
            var shouldShowSolidNavbarBackground = window.scrollY > (50 / 100) * windowHeight;
            var hasClass = Navbar.className.indexOf("navbar--solid-bg") < 0;
            //   if(shouldShowSolidNavbarBackground){
            //     if(hasClass){
            //       Navbar.classList.toggle('navbar--solid-bg');
            //     }
            //   }else{
            //     if(!hasClass){
            //       Navbar.classList.toggle('navbar--solid-bg');
            //     }
            //   }
        },
        formattedMenuLink(menuLink) {
            if (menuLink && menuLink.uri) {
                if (menuLink.uri.startsWith('http')) {
                    return menuLink.uri
                } else {
                    return process.env.VUE_APP_WK_FRONT_END_URL + menuLink.uri
                }
            } else {
                return ''
            }
        },
        handleResize() {
            this.isMobile = window.innerWidth <= 1230;
        },
    },
    computed: {
        goToCMSLogin() {
            return (
                "https://account.westkowloon.hk/" +
                this.$i18n.locale +
                "/my-westkowloon-login"
            );
        },
        homepageUrl() {
            return process.env.VUE_APP_WK_FRONT_END_URL + '/' + this.$i18n.locale;
        },
        backToWebsite() {
            return process.env.VUE_APP_WK_FRONT_END_URL + '/' + this.$i18n.locale;
        },
        currentRouteName() {
            return this.$route.name;
        },
        helpLink() {
            return process.env.VUE_APP_WK_FRONT_END_URL + '/' + this.$i18n.locale + '/help';
        },
        headerLogoStyle() {
            return {
                width: `${this.isMobile ? this.mobileLogoWidth : this.desktopLogoWidth}px`,
                height: `${this.isMobile ? this.mobileLogoHeight : this.desktopLogoHeight}px`,
            };
        },
        ...mapState(["debugging", "cart", "socialMediaIcons", "headerMenu", "topMenu", "headerButton", "popularSearchKeywords", "blackSiteLogo", "whiteSiteLogo", "textLogo", "logoLink", "desktopLogoHeight", "desktopLogoWidth", "mobileLogoHeight", "mobileLogoWidth"]),
        ...mapGetters(["inProduction"]),
        isDataLoaded() {
            return this.headerMenu.length > 0;
        },
    },
};
</script>
